import { render, staticRenderFns } from "./DeleteItemModal.vue?vue&type=template&id=22c78506"
import script from "./DeleteItemModal.vue?vue&type=script&lang=js"
export * from "./DeleteItemModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports